import angular from 'angular';

import ChangeLogComponent from './change-log.cmpt';

export default angular
    .module('application.component.change-log', [])
    .component(ChangeLogComponent.selector, ChangeLogComponent);



// WEBPACK FOOTER //
// ./src/application/component/change-log/index.js